"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ROICalculatorPresets = void 0;
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var ROIPresetsCard_1 = require("./ROIPresetsCard");
var ROIPresetID_1 = require("./ROIPresetID");
var ROICalculatorWrapper_1 = require("ContentTokens/SharedWidgetComponents/ROICalculator/ROICalculatorWrapper");
var withPolyfill_1 = __importDefault(require("react-resize-detector/build/withPolyfill"));
var classnames_1 = __importDefault(require("classnames"));
var presets = [
    {
        id: ROIPresetID_1.ROIPresetID.DollarsSaved,
        label: "Dollars Saved",
        imageUrl: "Assets/Images/ROIPresets/dollars-saved.png",
    },
    {
        id: ROIPresetID_1.ROIPresetID.TimeSaved,
        label: "Time Saved",
        imageUrl: "Assets/Images/ROIPresets/time-saved.png",
    },
    {
        id: ROIPresetID_1.ROIPresetID.SunkCost,
        label: "Sunk Cost",
        imageUrl: "Assets/Images/ROIPresets/sunk-cost.png",
    },
    {
        id: ROIPresetID_1.ROIPresetID.PercentageSaved,
        label: "Percentage Saved",
        imageUrl: "Assets/Images/ROIPresets/percentage-saved.png",
    },
    {
        id: ROIPresetID_1.ROIPresetID.ResourcesSaved,
        label: "Resources Saved",
        imageUrl: "Assets/Images/ROIPresets/resources-saved.png",
    },
    {
        id: ROIPresetID_1.ROIPresetID.Blank,
        label: "Blank",
        imageUrl: "Assets/Images/ROIPresets/blank.png",
    },
];
var isNarrowVariant = function (contentWidth) {
    return (contentWidth !== null && contentWidth !== void 0 ? contentWidth : 0) < 750;
};
var ROICalculatorPresets = (function (_super) {
    __extends(ROICalculatorPresets, _super);
    function ROICalculatorPresets() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleSelection = function (id) { return function () {
            _this.props.onSelection(id);
        }; };
        return _this;
    }
    ROICalculatorPresets.prototype.render = function () {
        var _this = this;
        var title = this.props.title;
        return (react_1.default.createElement(withPolyfill_1.default, null, function (_a) {
            var _b;
            var contentWidth = _a.width;
            return (react_1.default.createElement(ROICalculatorWrapper_1.ROICalculatorWrapper, null,
                react_1.default.createElement("div", { className: (0, classnames_1.default)("roi-presets-container", (_b = {},
                        _b["roi-presets-container--narrow"] = isNarrowVariant(contentWidth),
                        _b)) },
                    react_1.default.createElement("div", { className: "roi-presets-container__roi-presets" },
                        react_1.default.createElement("div", { className: "roi-presets-container__roi-presets__title" }, title),
                        react_1.default.createElement("div", { className: "roi-presets-container__roi-presets__wrapper" }, presets.map(function (preset) { return (react_1.default.createElement(ROIPresetsCard_1.ROIPresetsCard, { imageUrl: preset.imageUrl, label: preset.label, handleOnClick: _this.handleSelection(preset.id), key: preset.id })); }))))));
        }));
    };
    ROICalculatorPresets = __decorate([
        mobx_react_1.observer
    ], ROICalculatorPresets);
    return ROICalculatorPresets;
}(react_1.default.Component));
exports.ROICalculatorPresets = ROICalculatorPresets;
